import Field from './Field'

export default function FieldNumber (label, key, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'input-number'
}



// WEBPACK FOOTER //
// ./packages/helper/fields/FieldNumber.js